/**
 * Events Filters (pagine "Prossimi eventi" e "Risultati" — ELENCO_GARE.md § 3)
 *
 * - auto-submit con debounce sulla ricerca testuale
 * - auto-submit al cambio delle chip disciplina e degli input data custom (solo desktop)
 * - menu "Quando" (preset data): apertura/chiusura, click fuori, Escape
 * - toggle del pannello date personalizzate
 * - bottom sheet mobile: apertura/chiusura con backdrop, aria, focus
 *
 * Il form resta un semplice GET: prima dell'invio gli input vuoti vengono
 * disabilitati per non sporcare l'URL con parametri vuoti.
 */

class EventsFilters {
	constructor() {
		this.toolbar = document.querySelector(".events-toolbar");

		if (!this.toolbar) {
			return;
		}

		this.form = this.toolbar.querySelector(".events-toolbar__form");
		this.searchInput = this.toolbar.querySelector(".events-toolbar__search input");
		this.when = this.toolbar.querySelector(".events-toolbar__when");
		this.whenToggle = this.toolbar.querySelector(".events-toolbar__when-toggle");
		this.customToggle = this.toolbar.querySelector(".events-toolbar__when-custom");
		this.customDates = this.toolbar.querySelector(".events-toolbar__custom-dates");
		this.mobileToggle = this.toolbar.querySelector(".events-toolbar__mobile-toggle");
		this.panel = this.toolbar.querySelector(".events-toolbar__panel");
		this.backdrop = this.toolbar.querySelector(".events-toolbar__backdrop");

		this.mobileBreakpoint = window.matchMedia("(max-width: 767px)");

		this.init();
	}

	init() {
		this.initCleanNativeSubmit();
		this.initSearchDebounce();
		this.initDisciplineSelect();
		this.initWhenMenu();
		this.initCustomDates();
		this.initMobileSheet();
		this.initGlobalDismiss();
	}

	isMobile() {
		return this.mobileBreakpoint.matches;
	}

	// Disabilita i campi vuoti così l'URL resta pulito (niente ?discipline=&search_query=)
	disableEmptyFields() {
		this.form.querySelectorAll("input[name], select[name]").forEach(function(field) {
			if (field.value === "") {
				field.disabled = true;
			}
		});
	}

	submitClean() {
		this.disableEmptyFields();
		this.form.submit();
	}

	// Anche il submit nativo (bottone "Mostra le gare" nel bottom sheet, Enter) pulisce i campi vuoti
	initCleanNativeSubmit() {
		var self = this;
		this.form.addEventListener("submit", function() {
			self.disableEmptyFields();
		});
	}

	initSearchDebounce() {
		if (!this.searchInput) {
			return;
		}

		var self = this;
		var timer = null;
		var initialValue = this.searchInput.value;

		this.searchInput.addEventListener("input", function() {
			clearTimeout(timer);
			timer = setTimeout(function() {
				if (self.searchInput.value !== initialValue) {
					self.submitClean();
				}
			}, 500);
		});

		this.searchInput.addEventListener("keydown", function(event) {
			if (event.key === "Enter") {
				event.preventDefault();
				clearTimeout(timer);
				self.submitClean();
			}
		});
	}

	initDisciplineSelect() {
		var select = this.toolbar.querySelector(".events-toolbar__select select");

		if (!select) {
			return;
		}

		var self = this;

		select.addEventListener("change", function() {
			// su mobile la scelta si conferma col bottone "Mostra le gare"
			if (!self.isMobile()) {
				self.submitClean();
			}
		});
	}

	initWhenMenu() {
		if (!this.when || !this.whenToggle) {
			return;
		}

		var self = this;

		this.whenToggle.addEventListener("click", function(event) {
			event.stopPropagation();
			var isOpen = self.when.classList.toggle("is-open");
			self.whenToggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
		});
	}

	closeWhenMenu(restoreFocus) {
		if (this.when && this.when.classList.contains("is-open")) {
			this.when.classList.remove("is-open");
			this.whenToggle.setAttribute("aria-expanded", "false");
			if (restoreFocus) {
				this.whenToggle.focus();
			}
		}
	}

	initCustomDates() {
		if (!this.customToggle || !this.customDates) {
			return;
		}

		var self = this;

		this.customToggle.addEventListener("click", function(event) {
			event.stopPropagation();
			var isHidden = self.customDates.hasAttribute("hidden");

			if (isHidden) {
				self.customDates.removeAttribute("hidden");
				self.customToggle.setAttribute("aria-expanded", "true");
				self.closeWhenMenu(false);
				var firstDate = self.customDates.querySelector("input");
				if (firstDate) {
					firstDate.focus();
				}
			} else {
				self.customDates.setAttribute("hidden", "");
				self.customToggle.setAttribute("aria-expanded", "false");
			}
		});

		this.customDates.querySelectorAll("input[type=date]").forEach(function(dateInput) {
			dateInput.addEventListener("change", function() {
				if (!self.isMobile()) {
					self.submitClean();
				}
			});
		});
	}

	initMobileSheet() {
		if (!this.mobileToggle || !this.panel) {
			return;
		}

		var self = this;

		this.mobileToggle.addEventListener("click", function(event) {
			event.stopPropagation();
			if (self.panel.classList.contains("is-open")) {
				self.closeMobileSheet(true);
			} else {
				self.openMobileSheet();
			}
		});

		if (this.backdrop) {
			this.backdrop.addEventListener("click", function() {
				self.closeMobileSheet(true);
			});
		}
	}

	openMobileSheet() {
		this.panel.classList.add("is-open");
		this.mobileToggle.setAttribute("aria-expanded", "true");
		if (this.backdrop) {
			this.backdrop.removeAttribute("hidden");
		}
		var firstControl = this.panel.querySelector("a, button:not([hidden]), input");
		if (firstControl) {
			firstControl.focus();
		}
	}

	closeMobileSheet(restoreFocus) {
		if (!this.panel.classList.contains("is-open")) {
			return;
		}
		this.panel.classList.remove("is-open");
		this.mobileToggle.setAttribute("aria-expanded", "false");
		if (this.backdrop) {
			this.backdrop.setAttribute("hidden", "");
		}
		if (restoreFocus) {
			this.mobileToggle.focus();
		}
	}

	initGlobalDismiss() {
		var self = this;

		document.addEventListener("click", function() {
			self.closeWhenMenu(false);
		});

		document.addEventListener("keydown", function(event) {
			if (event.key === "Escape") {
				self.closeWhenMenu(true);
				self.closeMobileSheet(true);
			}
		});
	}
}

// Initialize when DOM is ready
if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", function() {
		new EventsFilters();
	});
} else {
	new EventsFilters();
}

export default EventsFilters;
